import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { Platform } from '@ionic/angular';
import { SmsRetriever } from '@ionic-native/sms-retriever/ngx';

@Component({
  selector: 'app-vendor-register',
  templateUrl: './vendor-register.component.html',
  styleUrls: ['./vendor-register.component.scss'],
})
export class VendorRegisterComponent {
  @ViewChild("videoPlayer", { static: false }) videoplayer: ElementRef;
  vendorReg:boolean=false;
  loader:boolean=false;
   popup:boolean=false;
   active:boolean=false;
   serviceInc:boolean=false;
   public smsTextmessage: string = '';
   public appHashString: string = '';
   numb;
   otpClicked:boolean;
  constructor(public service: ApiService,
    public router: Router,
    public location: LocationService,
    public handler: HandlerService,
    public auth: AuthService,
    private platform: Platform,
    public smsRetriever: SmsRetriever
) { }

ionViewWillEnter(){
  this.otpClicked = true;
  this.active=false;
}

  verify(){
    this.vendorReg=true;
    // this.router.navigate(['/vendorCategory'])  
  }

  switchUser(){
    // localStorage.removeItem('capability')
    // localStorage.removeItem('currentUserId')
    // localStorage.removeItem('organizationId')
    // localStorage.removeItem('capabilityOrg')
    // localStorage.removeItem('hashKey')
    // localStorage.removeItem('place')
    this.router.navigate(['/vendorLogin'])  
  }

  changeApp(){
    sessionStorage.setItem('vendorApp','false')
      if(this.auth.loged()){
        this.router.navigate(['/bookservice1']) 
      }else{
        this.router.navigate(['/bookservice']) 
      }
  }

  loginPop(){
    this.serviceInc=true;
  }

  closePop(){
    this.serviceInc=false;
    this.numb="";
  }

  closePop1(){
    this.vendorReg=false;
    this.numb="";
  }


  getHashCode() {
    this.otpClicked = false;
    if(this.platform.is('android')){
      this.smsRetriever.getAppHash()
      .then((res: any) => {
        this.appHashString = res;
        this.signIn();
      })
      .catch((error: any) => {
        this.signIn();
        console.error(error)});
    }else{
      this.signIn();
    }
  }

  signIn(){ 
    if(this.numb.length==10){
    var post={
    "contactNbrMob":'+91'+ this.numb
  }  
  if(this.platform.is('android')){
    Object.assign(post,{ "hashSms" : this.appHashString})
  }
  this.service.customerLogin(post).subscribe((res:any)=>{
   if(res){
    if(this.platform.is('android')){
      Object.assign(res,{ "hashSms" : this.appHashString})
    }
    // window['mock'] = res; 
    sessionStorage.setItem('contactNbrMob',this.numb) 
    this.handler.loginRes(res); 
     this.serviceInc=false;
     this.numb="";  
    this.router.navigate(['/employeeCheck'])
   }else{
     this.handler.res('Please Check The Number Entered')
     this.serviceInc=false;
   }},err => {
    this.handler.err(err);
    this.serviceInc=false;
    this.otpClicked = true;
  }) 
}else{
  this.handler.phNumError("Please enter valid mobile number")
  this.otpClicked = true;
}
}

ionViewWillLeave(){
  this.otpClicked = true;
  this.vendorReg = false;
  this.popup = false;
  this.numb="";
  this.videoplayer.nativeElement.src=" ";
}



getHashCodeReg() {
  this.otpClicked = false;
  if(this.platform.is('android')){
    this.smsRetriever.getAppHash()
    .then((res: any) => {
      this.appHashString = res;
      this.signInReg();
    })
    .catch((error: any) => {
      this.signInReg();
    });
  }else{
    this.signInReg();
  }
}
      

signInReg(){
  if(this.numb.length == 10){
    // sessionStorage.setItem('id',this.id)  
    var post={
      "contactNbrMob":'+91'+ this.numb,
      "orgCode":'YB',
      "paless": true,
      "userType":1,
      "verified":false,
      "roles": ['SC'], 
      "appId":14,
      "addresses":[
        {
          "cityId": this.location.cityId,
          "stateId": this.location.stateId,
          "regionId":this.location.regionId,
          "street":this.location.street,
          "zipcode":this.location.zipcode,
          "lat": this.location.lat,
          "lon": this.location.lon,
          "type": 2,
          "orgId":790
        }
      ]
    }  
    if(this.platform.is('android')){
      Object.assign(post,{ "hashSms" : this.appHashString})
    }
    this.service.vendorLogin(post).subscribe((res:any)=>{
     if(res){
      if(this.platform.is('android')){
        Object.assign(res,{ "hashSms" : this.appHashString})
      }
      // window['mock'] = res; 
      sessionStorage.setItem('contactNbrMob',this.numb) 
      this.handler.loginRes(res); 
       this.serviceInc=false;
       this.numb="";
   
       if(this.auth.loged()){
        this.router.navigate(['/regCont']) 
       }else{
        this.router.navigate(['/contractorReg'])
       }     
     }
    },err => {
      this.handler.err(err);
      this.otpClicked = true;
    })
  }else{
    this.handler.phNumError("Please enter valid mobile number")
    this.otpClicked = true;
  }
}

}
